<script lang="ts">
    import {ServiceConfig} from "../../../ServiceConfig";

    export let pageTitle;

    $: {
        const serviceName = ServiceConfig.ServiceName;
        document.title = `${pageTitle} - ${serviceName}`;
    }


</script>


